'use client';

import { useMemo } from 'react';
import type { MindmapInteractionState } from './mindmap-interaction-context';

interface UseCmarkdownmindmapInteractionStateInput {
  highlightedNodeIds: Set<string>;
  hoveredNodeId: string | null;
  isEntranceComplete: boolean;
  onToggleExpand: (nodeId: string) => void;
  selectedNodeId: string | null;
  setSelectedMindmapNode: (input: { nodeId: string | null }) => void;
}

export function useCmarkdownmindmapInteractionState({
  highlightedNodeIds,
  hoveredNodeId,
  isEntranceComplete,
  onToggleExpand,
  selectedNodeId,
  setSelectedMindmapNode,
}: UseCmarkdownmindmapInteractionStateInput): MindmapInteractionState {
  return useMemo<MindmapInteractionState>(() => ({
    onToggleExpand,
    selectedNodeId,
    onSelectNode: (nodeId) => setSelectedMindmapNode({ nodeId }),
    hoveredNodeId,
    highlightedNodeIds,
    isEntranceComplete,
  }), [
    highlightedNodeIds,
    hoveredNodeId,
    isEntranceComplete,
    onToggleExpand,
    selectedNodeId,
    setSelectedMindmapNode,
  ]);
}
